import type { StateTree } from '@makemydeal/dr-dash-types';
import { dealerSelectors, featureToggleSelectors } from '@makemydeal/dr-shared-store';

import * as dealLifecycleSelectors from './dealLifecycleSelectors';
import * as offerInfoSelectors from './offerInfoSelectors';
import * as offerReduxSelectors from './offerRedux';
import { buildQuoteName } from '../utils/quoteName';

export const getQuoteMode = (state: StateTree): boolean => {
    const isNoCustomerQuoteFeatureEnabled = featureToggleSelectors.isManagerViewQuoteModeEnabled(state);
    const isShopperInfoMissed = offerReduxSelectors.getIsShopperInfoMissed(state);

    return isNoCustomerQuoteFeatureEnabled && isShopperInfoMissed;
};

export const getIsQuoteModeWithoutDealXgRecord = (state: StateTree): boolean =>
    getQuoteMode(state) && offerReduxSelectors.getIsDealXgRecordMissed(state);

export const getQuoteName = (state: StateTree): string => {
    if (!getQuoteMode(state)) {
        return '';
    }

    const dealDate = offerInfoSelectors.getDealCreatedDate(state) || dealLifecycleSelectors.getDealLifecycleCreatedOn(state);

    return buildQuoteName({
        isDealXgRecordMissed: offerReduxSelectors.getIsDealXgRecordMissed(state),
        dealerId: dealerSelectors.getDealerId(state),
        creationDate: dealDate
    });
};
